import { defineStore } from 'pinia'
import { readonly, ref } from 'vue'

import { GetCampaignMemoData } from '@/typings/campaigns'

import { getCampaignMemo } from '../api/getCampaignMemo'
import { putCampaignMemo } from '../api/putCampaignMemo'

export const useCampaignMemoStore = defineStore('campaignMemoStore', () => {
  const memo = ref<GetCampaignMemoData | null>(null)
  const fetching = ref(false)
  const saving = ref(false)

  const fetchMemo = async (campaignId: number): Promise<void> => {
    if (fetching.value) return
    fetching.value = true
    try {
      memo.value = await getCampaignMemo(campaignId)
    } finally {
      fetching.value = false
    }
  }

  const saveMemo = async (campaignId: number, memoText: string): Promise<void> => {
    saving.value = true
    try {
      await putCampaignMemo(campaignId, memoText)
    } finally {
      saving.value = false
    }
  }

  const reset = (): void => {
    memo.value = null
    fetching.value = false
    saving.value = false
  }

  return {
    memo: readonly(memo),
    fetching: readonly(fetching),
    saving: readonly(saving),
    fetchMemo,
    saveMemo,
    reset
  }
})
